<template>
  <button @click="open" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1" type="button">
    <i class="fa fa-info"></i> {{ $t('templateList') }}
    <b-modal size="xl" v-model="showList" :title="'Brand name ' + brandName.name + ': ' + $t('templateList')" ok-only>
      <div class="c-template-table table-responsive c-role-table">
        <div class="c-template-table table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>{{ $t('name') }}</th>
              <th>{{ $t('info') }}</th>
              <th>{{ $t('status') }}</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody v-if="listLoading">
            <tr>
              <td colspan="4" class="text-center">
                <b-spinner></b-spinner>
              </td>
            </tr>
            </tbody>
            <tbody v-else-if="items && items.length">
            <tr v-for="item in items" :key="item._id">
              <td>{{ item.name ? item.name : $t('notUpdated') }}</td>
              <td>
                <p><span>{{$t('content')}}</span>: <b>{{ item.content }}</b></p>
                <p><span v-if="item.characterCount">{{$t('characterCount')}}: </span> <b>{{item.characterCount}}</b></p>
                <p><span v-if="item.numberOfSms">{{$t('numberOfSms')}}: </span> <b>{{item.numberOfSms}}</b></p>
              </td>
              <td>
                <label v-if="item.approveTime" class="badge badge-success">{{ $t('approved') }}</label>
                <label v-else class="badge badge-danger">{{ $t('denied') }}</label>
              </td>
              <td class="text-right">
                <button v-if="item.approveTime" @click="copy(item._id)"
                        class="mr-1 btn btn-outline-gray btn-sm is-border-1" type="button"
                        v-b-tooltip.hover.top="$t('copyId')">
                  <i class="icon12-copy-primary"></i>
                </button>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td class="text-center" colspan="4">{{ $t('noTemplateFound') }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
          <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                        v-model="filterFormModel.page" :total-rows="itemCount"
                        :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>
        </div>
      </div>
    </b-modal>
  </button>
</template>

<script>
import list from "../../../../mixins/List";

export default {
  mixins: [list],
  props: ['brandName'],
  data: function () {
    return {
      service: '/sms-template',
      autoLoad: false,
      defaultFilterFormModel: {
        brandName: this.brandName ? this.brandName._id : null
      },
      showList: false,
    }
  },
  methods: {
    open() {
      this.load();
      this.showList = true
    },
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('idCopied'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
  },
}
</script>